module.exports = __webpack_public_path__ + "components/rewards/twelve-day/static/logo-990963c161adaec3a0b3dbff30b6eaec.webp";